import {DescDocument, enumParamType} from '@/models/parameter.model';
import {variableGrammar} from '@/shared/jison/variable.grammar';
import {logicalGrammar} from '@/shared/jison/logical.grammar';
import {stringGrammar} from '@/shared/jison/string.grammar';
import {calcGrammar} from '@/shared/jison/calc.grammar';
import {datetimeGrammar} from '@/shared/jison/datetime.grammar';
import {optionGrammar} from '@/shared/jison/option.grammar';

const Parser = require('jison').Parser;

export class JisonParser {
  public error: string | null = null;
  public result: any = null;
  private jparser: any;


  public constructor(grammar: any) {
    this.jparser = new Parser(grammar);
  }

  public static builder(desc: DescDocument) {
    // console.log('builder value=', value ,' desc=', {...desc});
    const options = desc.type === enumParamType.options && desc.options ? desc.options : [];
    const grammar = typeGrammar(desc.type, false, options);
    try {
      return new JisonParser(grammar);
    } catch (e) {
      // console.log(`grammar '${desc.type}' => ERROR : `, e.message);
      return null;
    }
  }

  public exec(exp: string): boolean | string {
    try {
      // const ret = this.jparser.parse(exp);
      // console.log(`Parse expression '${exp}' :`, ret);
      return true;
    } catch (e: any) {
      // console.log(`Error parse expression '${exp}' :`, e.message);
      const m: string[] = e.message.split('\n');
      if (m.length >= 2 && m[2].match(/^[\-]*\^$/)) {
        const pos = m[2].length;
        return pos > exp.length
          ? 'Expression incomplete'
          : `Syntax error near character '${exp.charAt(pos - 1)}' at position ${pos}`;
      } else {
        return e.message;
      }
    }
  }

}

function typeGrammar(type: enumParamType, solve: boolean = false, options: string[] = []): any {
  // console.log(`typeGrammar '${type}', solve=${solve}, options=`, options)
  switch (type) {
    case enumParamType.receipt :
      return variableGrammar;
    case enumParamType.booldata:
      return logicalGrammar(solve);
    case enumParamType.textdata:
      return stringGrammar(solve);
    case enumParamType.numbdata:
      return calcGrammar(solve);
    case enumParamType.datetime :
      return datetimeGrammar(solve);
    case enumParamType.options :
      return optionGrammar(solve, options);
  }
}
